import React from 'react';
import { Box, Typography, Paper, Grid, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import InventoryIcon from '@mui/icons-material/Inventory';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import PageContainer from '../../components/layout/PageContainer';

const InventoryPage: React.FC = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: 'Stock In',
      description: 'Record new stock received',
      icon: <InventoryIcon sx={{ fontSize: 40 }} color="primary" />,
      path: '/inventory/stock-in',
    },
    {
      title: 'Stock Out',
      description: 'Record stock dispensed, disposed, or transferred',
      icon: <ExitToAppIcon sx={{ fontSize: 40 }} color="secondary" />,
      path: '/inventory/stock-out',
    },
    {
      title: 'Stock Transfer',
      description: 'Transfer stock between locations',
      icon: <LocalShippingIcon sx={{ fontSize: 40 }} color="action" />,
      path: '/inventory/stock-transfer',
    },
  ];

  return (
    <PageContainer title="Inventory Management">
      <Box sx={{ mt: 3 }}>
        <Typography variant="h5" gutterBottom>
          Inventory Management
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Manage your inventory operations including stock in, stock out, and transfers between locations.
        </Typography>
        
        <Grid container spacing={3} sx={{ mt: 2 }}>
          {menuItems.map((item) => (
            <Grid item xs={12} sm={6} md={4} key={item.path}>
              <Paper 
                elevation={3} 
                sx={{ 
                  p: 3, 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  textAlign: 'center',
                  cursor: 'pointer',
                  '&:hover': {
                    boxShadow: 6,
                  },
                }}
                onClick={() => navigate(item.path)}
              >
                <Box mb={2}>
                  {item.icon}
                </Box>
                <Typography variant="h6" gutterBottom>
                  {item.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {item.description}
                </Typography>
                <Button 
                  variant="outlined" 
                  size="small" 
                  sx={{ mt: 2 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(item.path);
                  }}
                >
                  Go to {item.title}
                </Button>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default InventoryPage;
